import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Dropdown } from '../../../../../components';
import InputField from '../../../../../components/InputField';
import axiosInstance from '../../../../../services/AxiosInstance';
import SimpleReactValidator from 'simple-react-validator';
import { userContext } from '../../../../../contextProvider/Authentication';
import swal from 'sweetalert';
import { getAPIIds } from '../../../../../Functions/apis';

function Degree({ stud_id }) {

    const [employment, setEmployment] = useState(false);
    const [degree, setDegree] = useState();
    const [input, setInput] = useState({});
    const { user } = useContext(userContext);
    const [, forceUpdate] = useState();
    const simpleValidator = useRef(new SimpleReactValidator());

    useEffect(() => {
        getDegree();
        // eslint-disable-next-line
    }, []);

    const getDegree = () => {
        var url = stud_id ? `can-degrees/?candidate=${stud_id}` : "can-degrees/";
        axiosInstance(
            url, {
            method: 'GET',
            data: {}
        }).then(res => {
            setDegree(res.data.results);
        }).catch(err => {
            swal("", Object.values(err.response.data), "error", { button: "Ok!", })
        })
    }

    const handlechange = (e, name, type) => {
        if (["dropdown"].includes(type)) {
            setInput({ ...input, [name]: e });
            if (name === "degree_level") setInput({ ...input, [name]: e, "degree": {} });
        } else {
            setInput({ ...input, [e.target.name]: e.target.value });
        }
    }

    const handleSubmit = () => {
        if (!(simpleValidator.current.allValid())) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            input["degree_level"] = input?.degree_level?.id || null;
            input["candidate"] = input?.candidate?.id || null;
            input["country"] = input?.country?.id || null;
            input["degree"] = input?.degree?.id || null;
            input["studied_subjects"] = getAPIIds(input?.studied_subjects);
            input["candidate"] = stud_id ?? user.id;

            var url = input?.id ? `can-degrees/${input.id}/` : "can-degrees/";
            var method = input?.id ? "PUT" : "POST";

            axiosInstance(
                url, {
                method: method,
                data: input
            }).then(res => {
                if (res?.status === 201 || res?.status === 200) {
                    setInput({});
                    setEmployment(false);
                    getDegree();
                    swal("", `Degree ${res?.status === 201 ? "added" : "updated"} successfully`, "success", { button: "Ok!", })
                }
            }).catch(err => {
                setEmployment(false);
                setInput({});
                swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", })
            })
        }
    }

    const handleDelete = (id) => {
        axiosInstance(
            `can-degrees/${id}/`, {
            method: "DELETE",
        }).then(res => {
            swal("", `Degree deleted successfully`, "success", { button: "Ok!", });
            getDegree();
        }).catch(err => {
            swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok!", });
        })
    }

    const handleEdit = (res) => {
        setInput(res);
        setEmployment(true);
    }

    const handleClose = () => {
        setEmployment(false);
        setInput({});
    }

    return (
        <div>
            <div className="d-flex">
                <h5 className="m-b15">Education - Degree</h5>
                <Link to={"#"} onClick={() => setEmployment(true)} className="site-button add-btn button-sm"><i className="fa fa-plus m-r5"></i> Add Degree</Link>
            </div>
            <div className="row">
                {
                    degree?.map(res => {
                        return (
                            <div className="col-12 col-md-6" key={res.degree?.name}>
                                <Card className="mb-2">
                                    <Card.Body className="p-3">
                                        <div className="d-flex">
                                            <h6 className="font-14 m-b0">{res.degree?.name} -&nbsp; </h6> {res.percentage}%
                                            <Link
                                                to={"#"}
                                                onClick={() => handleEdit(res)}
                                                className="site-button add-btn button-sm"
                                            >
                                                <i className="fa fa-pencil" />
                                            </Link>
                                            <Link
                                                to={"#"}
                                                onClick={() => handleDelete(res?.id)}
                                                className="site-button ml-2 add-btn button-sm btn-danger"
                                                title='Delete'
                                            >
                                                <i className="ti-trash" />
                                            </Link>
                                        </div>
                                        <p className="mb-0">{res.university_name} University, {res.country?.name}</p>
                                    </Card.Body>
                                </Card>
                            </div>
                        )
                    })
                }
            </div>


            <Modal show={employment} size="lg" onHide={setEmployment} className="modal fade modal-bx-info" >
                <div className="my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="EmploymentModalLongTitle">Add Degree</h5>
                            <button type="button" className="close" onClick={handleClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <Dropdown
                                            url="qualification-level/"
                                            onChange={handlechange}
                                            value={input.degree_level}
                                            name="degree_level"
                                            required={true}
                                            title="Degree Level"
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message('degree level', input.degree_level, 'required')}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <Dropdown
                                            url="qualification/"
                                            onChange={handlechange}
                                            filters={`level=${input?.degree_level?.id}`}
                                            value={input.degree}
                                            name="degree"
                                            required={true}
                                            title="Degree"
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message("degree", input.degree, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <Dropdown
                                            url="country/"
                                            onChange={handlechange}
                                            value={input.country}
                                            name="country"
                                            required={true}
                                            title="Country"
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message("country", input.country, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <InputField
                                            label="University Name"
                                            name="university_name"
                                            value={input.university_name}
                                            onChange={handlechange}
                                            required={true}
                                            placeholder="Enter University Name"
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message("university name", input.university_name, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <InputField
                                            label="Percentage"
                                            type="number"
                                            name="percentage"
                                            value={input.percentage}
                                            onChange={handlechange}
                                            required={true}
                                            placeholder="eg. 75.5"
                                            onKeyPress={e => e.target.value.length >= 4 && e.preventDefault()}
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message("percentage", input.percentage, "required|lte:100|gt:0")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <Dropdown
                                            url="course/"
                                            type='multiple'
                                            onChange={handlechange}
                                            value={input.studied_subjects}
                                            name="studied_subjects"
                                            required={true}
                                            title="Studied Subjects"
                                        />
                                        <span className="text-danger font-weight-bold">
                                            {simpleValidator.current.message("studied subjects", input.studied_subjects, "required")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <InputField
                                            label="Additional Information"
                                            name="additional_info"
                                            textType="textarea"
                                            value={input.additional_info}
                                            onChange={handlechange}
                                            required={false}
                                            placeholder="Enter Additional Information"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="site-button" onClick={handleClose} >Cancel</button>
                            <button
                                type="button"
                                className="site-button"
                                onClick={handleSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    );
}

export default Degree;